import React from 'react';
import './styles.scss';
import { useConfigStore } from '@/hooks';
import { useCustomComponent } from '@/hooks';
import clsx from 'clsx';
import Components from './components';

export interface TypingIndicatorProps {
  className?: string;
}

const TypingIndicatorComponent: React.FC<TypingIndicatorProps> = ({
  className,
}) => {
  const {
    theme: {
      branding: { avatars },
    },
  } = useConfigStore();

  return (
    <Components.Container
      className={clsx('peptalk-typing-indicator', className)}
    >
      <Components.AvatarSlot
        url={avatars[0].url}
        alt={avatars[0].alt}
        height={'42px'}
        width={'42px'}
        border={false}
      />
      <Components.Dots />
    </Components.Container>
  );
};

export const TypingIndicator: React.FC<TypingIndicatorProps> = (
  props: TypingIndicatorProps
) => {
  const Component = useCustomComponent({
    componentName: 'TypingIndicator',
    Component: TypingIndicatorComponent,
  });

  return <Component {...props} />;
};
